// extracted by mini-css-extract-plugin
export default {"base":"EmptyMap_base__CZ-r4","loading":"EmptyMap_loading__OoyFq"};